import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';

import SimpleGrid, { TableRowData } from '../core/SimpleGrid';
import { formatAbnOrAcn } from '../../utils/formatter';

const AbnGrid = (props) => {
  const { data, onRowSelected, selectedRowId, error, width, fixedIdLabelValue } = props;
  const [stateSelectedRow, setSelectedRow] = useState(selectedRowId);

  if (!data || (!data.length && !error)) {
    return null;
  }

  const handleRowSelect = (e, row) => {
    const hasChanged = row.id !== stateSelectedRow;
    if (hasChanged) {
      setSelectedRow(row.id);
      onRowSelected(e, row);
    }
  };

  const renderRowsForNonMobile = () => {
    if (!data.length && error) {
      return (
        <TableRowData key="empty">
          <TableCell colSpan={3} align="center">
            {error}
          </TableCell>
        </TableRowData>
      );
    }

    return data.map((row) => {
      const isSelected = row.id === stateSelectedRow;
      const enrichedRowData = {
        ...row,
        isTrustee: fixedIdLabelValue === 'ACN',
      };

      return (
        <TableRowData
          hover={!isSelected}
          key={row.id}
          selected={isSelected}
          onClick={(e) => handleRowSelect(e, enrichedRowData)}
          data-testid={`tbDataRow-${row.id}`}
        >
          <TableCell> {formatAbnOrAcn(fixedIdLabelValue === 'ACN' ? row.acn : row.id)}</TableCell>
          <TableCell>{row.entityName}</TableCell>
          <TableCell>
            {row.businessAddress.postcode}
            <span> </span>
            {row.businessAddress.state}
          </TableCell>
        </TableRowData>
      );
    });
  };

  const renderRowsForMobile = () => {
    if (!data.length && error) {
      return (
        <TableRowData>
          <TableCell>
            <Grid container>
              <Grid item xs={12}>
                {error}
              </Grid>
            </Grid>
          </TableCell>
        </TableRowData>
      );
    }

    return data.map((row) => {
      const isSelected = row.id === stateSelectedRow;
      return (
        <TableRowData
          key={row.id}
          selected={isSelected}
          onClick={(e) => handleRowSelect(e, row)}
          data-testid={`tbDataRow-${row.id}`}
        >
          <TableCell>
            <Grid container>
              <Grid item xs={12}>
                {formatAbnOrAcn(fixedIdLabelValue === 'ACN' ? row.acn : row.id)}
              </Grid>
              <Grid item xs={12}>
                {row.entityName}
              </Grid>
              <Grid item xs={12}>
                {row.businessAddress.postcode} {row.businessAddress.state}
              </Grid>
            </Grid>
          </TableCell>
        </TableRowData>
      );
    });
  };

  const isMobile = isWidthDown('xs', width);

  const idHeaderValue = props.fixedIdLabelValue === 'ACN' ? 'ACN' : 'ABN';

  return (
    <SimpleGrid
      columnNames={isMobile ? null : [idHeaderValue, 'Name', 'Location']}
      renderRows={isMobile ? renderRowsForMobile : renderRowsForNonMobile}
    />
  );
};

AbnGrid.propTypes = {
  data: PropTypes.array,
  onRowSelected: PropTypes.func.isRequired,
  selectedRowId: PropTypes.any,
  error: PropTypes.string,
  width: PropTypes.string,
  fixedIdLabelValue: PropTypes.string,
};

AbnGrid.defaultProps = {
  data: null,
  selectedRowId: null,
  error: null,
  width: 'sm',
  fixedIdLabelValue: null,
};

export default withStyles({}, { withTheme: true })(withWidth()(AbnGrid));
